import { render } from "./PaperSearch.vue?vue&type=template&id=6c813e58"
const script = {}

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/Components/PaperSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c813e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c813e58', __exports__)) {
    api.reload('6c813e58', __exports__)
  }
  
  module.hot.accept("./PaperSearch.vue?vue&type=template&id=6c813e58", () => {
    api.rerender('6c813e58', render)
  })

}


export default __exports__